import {
  DataGrid,
  GridActionsCellItem,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Broker, getBankReconciliationTable, downloadBrokerInfo } from "../../Services/api";
import instance from "../../redux/api";
import { CommonButton } from "../common/commonButton";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormLabel,
  Grid,
  IconButton,
  Stack,
  TableContainer,
  TextField,
  Tooltip,
} from "@mui/material";
import { ViewAndEditEntity } from "./ViewAndEditEntity";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { toast } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MyComponent from "../EntityTableMaintainance/EntityDetails";
import { AddBrokerDetails } from "./AddBinding";
import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";
import { CommonPaginationContainer } from "../common";
import { styled } from '@mui/material/styles';
import { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { CommonSelect } from "../common";
import {
  getBrokerBranchesList
} from "../../redux/slice/bankStatmentTransactionsSlice";
import { commonToast } from "../common";
import format from "date-fns/format";

//styles

const AssignBankStatementBar = {
  display: "flex",
  justifyContent: "space-between",
  height: 32,
  fontWeight: "400",
  marginTop: 10,
};
const editEntityUpdate = {
  width: "90px",
  padding: "18px 0px",
  borderRadius: "20px",
  gap: "8px",
};

const bankTransactionAddBtn = {
  background: "#FF5A01",
  marginLeft: "5%",
  color: "white",
  borderRadius: "10px",
  padding: "5px 20px",
};

const bankStatementSearchBar = {
  width: "230px",
  height: "30px",
  padding: "2px 5px 1px 15px",
  borderRadius: "7px",
  border: "1px solid #d2cccc",
  marginTop: "5px",
};

const dialogStyle = {
  maxWidth: "90vw",
  width: "90vw",
  margin: "auto",
};
const ResetSubmit = {
  justifyContent: "flex-end",
  paddingTop: "0px",
  marginRight: "12px",
};
const addBankTransactionReset = {
  backgroundColor: "white",
  width: "90px",
  padding: "16px 0px",
  borderRadius: "20px",
  gap: "8px",
  color: "black",
  border: "1px solid black",
};

const EditPageContainerTransactions = {
  padding: "10px",
  cursor: "default",
  width: "100%",
  marginLeft: "-10px",
};
const EditPageContainerTransactionsList = {
  display: "flex",
  justifyContent: "end",
  width: "100%",
  alignItems: "center",
  marginBottom: "10px",
};

const CloseIconStyle = {
  backgroundColor: "#3B3F44",
  color: "#ffff",
  height: "16px",
  width: "16px",
  padding: "7px 8px",
  borderRadius: "32px",
};
const addBankTransactionSubmit = {
  backgroundColor: "#FF5A01",
  width: "90px",
  padding: "17px 0px",
  borderRadius: "13px",
  gap: "8px",
  color: "white",
};
const EmailPhoneNoTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#ffffff',
    color: 'rgba(0, 0, 0)',
    maxWidth: 300,
    border: '1px solid #000000',
    borderRadius: '0px'
  },
}));
const downloadBtn = {
  background: "#FF5A01",
  marginLeft: "5%",
  color: "white",
  borderRadius: "10px",
  padding: "5px 25px !important",
  whiteSpace: "nowrap"
};

export default function BrokerContainer() {
  // Selectors
  const toggle = useSelector((state) => state.toggleSideMenu);
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state?.user);
  const dropdownValuesBrokerBranch = useSelector(
    (state) => state?.bankStatmentTransactions?.brokerBranchesList
  );
  const [rows, setRows] = useState([
    {
      broker_name: "",
      broker: "",
      branch: "",
      duplicate_count: "",
      soa_received_from_broker: "",
      name: "",
      email: "",
      secondary_email: "",
      phone_number: "",
      broker_branch_location: "",
      bank_acc_name: "",
      bank_acc_number: "",
      currency: "",
      iban_number: "",
      payee_name: "",
      swift_number: "",
      sort_code: ""
    },
  ]);
  const [tableRows, setTableRows] = useState([]);
  const [isApiCallInprogress, setIsApiCallInprogress] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [EntityDialog, setEntityDialog] = useState(false);
  const [editRow, setEditRow] = useState("");
  const [viewMode, setViewMode] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isCreated, setIsCreated] = useState(true);
  const [editId, setEditId] = useState("");

  // const [pageSize, setPageSize] = useState(5);
  // const [page, setPage] = useState(0);

  const [currentUpdatedFiledsInEditMode, setCurrentUpdatedFiledsInEditMode] =
    useState({});
  const [validationStatus, setValidationStatus] = useState(
    Array(rows.length).fill(true)
  );

  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchFieldParams, setSearchFieldParams] = useState({
    Broker_Name: "",
    Broker_Branch: "",
    Broker_Email: ""
  });
  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [isClearPerformed, setIsClearPerformed] = useState(false);
  const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);
  const classes = useStyles();

  //For pagination
  const [paginationCount, setPaginationCount] = useState(0);
  const [pageState, setPageState] = useState({
    isLoading: true,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
  });

  // skip 0 means page 1
  const currentSkipNumber = () => {
    return pageState?.page === 1
      ? 0
      : pageState?.page === 0
      ? pageState?.page
      : pageState?.page - 1;
  };

  useEffect(() => {
    if (pageState?.total >= 5) {
      setPaginationCount(Math.floor(pageState.total / pageState?.pageSize));
    } else setPaginationCount(0);
  }, [pageState.total]);

  useEffect(() => {
    if (!isClearPerformed) {
      loadData();
    }
  }, [pageState?.pageSize, pageState?.page]);

  useEffect(() => {
    if (isClearPerformed) {
      loadData();
      setIsClearPerformed(false);
    }
  }, [isClearPerformed]);
  
  useEffect(() => {
    dispatch(getBrokerBranchesList());
  }, [])

  const loadData = async () => {
    try {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));
      let queryParams = `skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize}`;
      if (isSearchPerformed) {
        const { Broker_Name, Broker_Branch, Broker_Email } = searchFieldParams;
        if (Broker_Name) {
          queryParams = `${queryParams}&brokerName=${Broker_Name}`;
        }
        if (Broker_Branch) {
          queryParams = `${queryParams}&brokerBranch=${Broker_Branch}`;
        }
        if (Broker_Email) {
          queryParams = `${queryParams}&brokerEmail=${Broker_Email}`;
        }
      }
      const response = await instance.get(
        `${Broker}?${queryParams}`
      );
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
        }));
        setPaginationCount(
          Math.floor(response?.data?.count / pageState?.pageSize)
        );
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.error("err", err);
    }
  };

  const handleEnter = (e) => {
    if (e.code === "Enter") {
      handleSearchAdmnBrokerList();
    }
  };

  const handleBrokerInputChange = (value) => {
    setSearchFieldParams({
      ...searchFieldParams,
      Broker_Name: value ?? "",
    });
    if (isSearchPerformed && !value) {
      handleClearSearchList();
    }
  };

  // Handler for Broker Branch Dropdown
  const handleBrokerBranchDropdownChange = (name, value, reason) => {
    /*
    if (reason === "clear") {
      setSearchFieldParams((prev) => ({
        ...prev,
        [name]: "",
      }));
    } else {
      setSearchFieldParams((prev) => ({ ...prev, [name]: value }));
    }
    */
    setSearchFieldParams((prev) => ({ ...prev, [name]: value ?? "" }));

    if (isSearchPerformed && !value) {
      const searchFields = searchFieldParams;
      delete searchFields[name];
      if (Object.values(searchFields).every(value => !value)) {
        handleClearSearchList();
      }
    }
  };

  const handleSearchInputchange = (name, value) => {
    setSearchFieldParams({
      ...searchFieldParams,
      [name]: value ?? ""
    });
    if (isSearchPerformed && !value) {
      const searchFields = searchFieldParams;
      delete searchFields[name];
      if (Object.values(searchFields).every(value => !value)) {
        handleClearSearchList();
      }
    }
  };

  const handleSearchAdmnBrokerList = async () => {
    try {
      let queryParams = `?skip=0&pageSize=${pageState?.pageSize}`;

      const { Broker_Name, Broker_Branch, Broker_Email } = searchFieldParams;
      if (Broker_Name) {
        queryParams = `${queryParams}&brokerName=${Broker_Name}`;
      }
      if (Broker_Branch) {
        queryParams = `${queryParams}&brokerBranch=${Broker_Branch}`;
      }
      if (Broker_Email) {
        queryParams = `${queryParams}&brokerEmail=${Broker_Email}`;
      }

      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      const response = await instance.get(`${Broker}${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        console.log("broker", response);
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
          page: 1
        }));
        setIsSearchPerformed(true);
        setPaginationCount(
          Math.floor(response?.data?.count / pageState?.pageSize)
        );
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count ?? 0,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));
      console.log("err", err);
    }
  };

  const isFilterBtnDisable = () => {
    let disabled = true;
    const { Broker_Name, Broker_Branch, Broker_Email } = searchFieldParams;
    if (Broker_Name !== "" || Broker_Branch !== "" || Broker_Email != "") {
      disabled = false;
    }
    return disabled;
  };

  const handleClearSearchList = () => {
    setIsSearchPerformed(false);
    setSearchFieldParams({
      Broker_Name: "",
      Broker_Branch: "",
      Broker_Email: ""
    });
    setPageState((old) => ({
      ...old,
      page: 1
    }));
    setIsClearPerformed(true);
  };

  const Container = {
    width: toggle?.isOpen ? "calc(100vw - 305px)" : "calc(100vw - 100px)",
    display: "flex",
    flexDirection: "column",
    gap: 8,
  };

  const handleDialogClose = () => {
    setEntityDialog(false);
    setEditMode(false);
    setViewMode(false);
    if (!editMode && !viewMode) {
      setRows([
        {
          broker_name: "",
          broker: "",
          branch: "",
          duplicate_count: "",
          soa_received_from_broker: "",
          name: "",
          email: "",
          secondary_email: "",
          phone_number: "",
          broker_branch_location: "",
          bank_acc_name: "",
          bank_acc_number: "",
          currency: "",
          iban_number: "",
          payee_name: "",
          swift_number: "",
          sort_code: ""
        },
      ]);
      setSelectedRows([false]);
      setValidationStatus([true]);
    }
    else if(editMode){
      setValidationStatus([true]);
      setCurrentUpdatedFiledsInEditMode({});
    }
  };

  // const handleSearch = (e) => {
  //   const value = e.target.value;
  //   setSearchText(value);
  //   let filteredData;
  //   if (value.trim() === '') {
  //     loadData();
  //     filteredData = tableRows;
  //   } else {
  //     filteredData = tableRows.filter((row) =>
  //       columns.some((column) => {
  //         const cellValue = row[column.field];
  //         if (Array.isArray(cellValue)) {
  //           // Check if the array is not null
  //           if (cellValue !== null && cellValue !== undefined) {
  //             // Check if any property within the objects in the array includes the search value
  //             return cellValue.some((item) =>
  //               Object.values(item).some(
  //                 (propValue) =>
  //                   propValue !== undefined &&
  //                   propValue !== null &&
  //                   propValue.toString().includes(value)
  //               )
  //             );
  //           }
  //         } else if (cellValue !== undefined && cellValue !== null) {
  //           // For non-array fields, continue with the existing logic
  //           return cellValue.toString().includes(value);
  //         }
  //         return false;
  //       })
  //     );
  //   }
  //   setTableRows(filteredData);
  // };

  useEffect(() => {
    if (selectAll) {
      const updatedSelectedRows = [...selectedRows];
      updatedSelectedRows.fill(selectAll);
      setSelectedRows(updatedSelectedRows);
    }
  }, [selectAll]);

  const handleCheckboxChange = (index, isChecked) => {
    const updatedSelectedRows = [...selectedRows];
    updatedSelectedRows[index] = isChecked;

    // Check the number of selected rows
    const selectedRowCount = updatedSelectedRows.filter(Boolean).length;
    setSelectedRows(updatedSelectedRows);
    setSelectAll(selectedRowCount === rows.length);
  };

  const handleActionButton = async (rowData, isEditMode, rowIndex = null) => {    
    if (rowIndex != null) {
      const rowId = rowData.id;
      const decryptData = async (type) => {
        const payload = { id: rowId, type };
        const response = await instance.post('/documents/decrypt_data/', payload);
        if (response.status === 200) {
          return response.data;
        }
        return null;
      };
    
      const [emailDecrypted, phoneDecrypted] = await Promise.all([
        decryptData('decrypted_email'),
        decryptData('decrypted_phone_number')
      ]);
    
      if (emailDecrypted) {
        rowData.decrypted_email = emailDecrypted.decrypted_email;
      }
    
      if (phoneDecrypted) {
        rowData.decrypted_phone_number = phoneDecrypted.decrypted_phone_number;
      }
    }   
    
    const emptyRows = Array.from({ length: rows.length }, () => ({
      broker_name: "",
      broker: "",
      branch: "",
      duplicate_count: "",
      soa_received_from_broker: "",
      name: "",
      email: "",
      secondary_email: "",
      phone_number: "",
      broker_branch_location: "",
    }));

    if (rowData && isEditMode) {
      // Pre-fill the empty row with data for editing
      setRows([{...rowData}]);
      setEditRow(rowData);
      setEditMode(true);
      setEditId(rowData.id);
      setIsCreated(false);
    } else if (rowData && !isEditMode) {
      setRows([rowData]);
      setViewMode(true);
    } else {
      // If no rowDataForEdit is provided, it means we are in add mode
      setRows(emptyRows);
      setIsCreated(true);
      setEntityDialog(true);
    }
    setEntityDialog(true);
    if (rowData) {
      setIsCreated(false);
    } else {
      setIsCreated(true);
    }
  };
  const columns = [
    { field: "id", headerName: "ID", width: 20, headerAlign: "center" },
    {
      field: "broker_name",
      headerName: "Broker Master",
      width: 200,
      headerAlign: "center",
    },
    // {
    //   field: "broker",
    //   headerName: "Broker",
    //   flex: 1,
    //   headerAlign: "center",
    // },
    {
      field: "branch",
      headerName: "Broker Branch",
      width: 200,
      headerAlign: "center",
    },
    {
      field: "duplicate_count",
      headerName: "Duplicate Count",
      width: 120,
      headerAlign: "center",
      renderCell: (params) => (
        <span>{parseInt(params?.row?.duplicate_count)}</span>
      ),
    },
    {
      field: "soa_received_from_broker",
      headerName: "Soa Received",
      width: 100,
      headerAlign: "center",
    },
    {
      field: "name",
      headerName: "Broker Representative",
      width: 180,
      headerAlign: "center",
    },
    {
      field: "decrypted_email",
      headerName: "Email",
      width: 300,
      headerAlign: "center",
      renderCell: (params) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <EmailPhoneNoTooltip title={params.value || ""}> 
            {params.value}
          </EmailPhoneNoTooltip>
          {(userData?.role?.toLowerCase() === "manager" || userData?.role === "CC Processor" || userData?.role === "lead role") && params.value != 'nan' && (
            <IconButton
              onClick={() => handleDecryptClick(params.api.getRowIndex(params.id), params.id, 'decrypted_email', params.row)}
              size="small"
            >
              <VisibilityIcon />
            </IconButton>
          )}
        </div>
      ),
    },
    // added secondary email column on broker
    {
      field: "secondary_email",
      headerName: "Secondary Email",
      width: 150,
      headerAlign: "center",
    },
    {
      field: "decrypted_phone_number",
      headerName: "Phone Number",
      width: 160,
      headerAlign: "center",
      renderCell: (params) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <EmailPhoneNoTooltip title={params.value || ""}>
            {params.value}
          </EmailPhoneNoTooltip>
          {(userData?.role?.toLowerCase() === "manager" || userData?.role === "CC Processor" || userData?.role === "lead role") && params.value != 'nan' && (
            <IconButton
              onClick={() => handleDecryptClick(params.api.getRowIndex(params.id), params.id, 'decrypted_phone_number', params.row)}
              size="small"
            >
              <VisibilityIcon />
            </IconButton>
          )}
        </div>
      ),
    },
    {
      field: "broker_branch_location",
      headerName: "Broker Branch Location",
      width: 180,
      headerAlign: "center",
    },
    {
      field: "bank_acc_name",
      headerName: "Bank Acc Name",
      width: 180,
      headerAlign: "center",
    },
    {
      field: "bank_acc_number",
      headerName: "Bank Acc #",
      width: 180,
      headerAlign: "center",
    },
    {
      field: "currency",
      headerName: "Currency",
      width: 180,
      headerAlign: "center",
    },
    {
      field: "iban_number",
      headerName: "iban #",
      width: 180,
      headerAlign: "center",
    },
    {
      field: "payee_name",
      headerName: "Payee name",
      width: 180,
      headerAlign: "center",
    },
    {
      field: "swift_number",
      headerName: "Swift #",
      width: 180,
      headerAlign: "center",
    },
    {
      field: "sort_code",
      headerName: "Sort Code",
      width: 180,
      headerAlign: "center",
    },
    {
      field: "created_by",
      headerName: "Created By",
      width: 150,
      headerAlign: "center",
      valueGetter: (params) => params?.value ?? "-",
    },
    {
      field: "updated_by",
      headerName: "Last Modified By",
      width: 150,
      headerAlign: "center",
      valueGetter: (params) => params?.value ?? "-",
    },
    ...(userData?.role !== "CC Processor"
      ? [
          {
            field: "actions",
            type: "actions",
            headerName: "Actions",
            width: 160,
            cellClassName: "actions",
            getActions: ({ row }) => {
              let actionsList = [];

              if (UserAuthorisation?.["Edit"] === "Y") {
                actionsList.push(
                  <GridActionsCellItem
                    icon={
                      <Tooltip title="Edit">
                        {" "}
                        <EditIcon />{" "}
                      </Tooltip>
                    }
                    label="Edit"
                    className="textPrimary"
                    onClick={() => {
                      const rowIndex = pageState?.data.findIndex(
                        (item) => item.id === row.id
                      );
                      handleActionButton(row, true, rowIndex); 
                    }}
                    color="inherit"
                  />
                );
              }

              // if (bankTransactions?.['Delete'] === "Y") {
              //   actionsList.push(
              //     <GridActionsCellItem
              //       icon={<Tooltip title="Delete"><DeleteIcon /> </Tooltip>}
              //       label="Delete"
              //       onClick={() => handleDeleteClick(row.id)}
              //       color="inherit"
              //     />
              //   );
              // }

              if (UserAuthorisation?.["View"] === "Y") {
                actionsList.push(
                  <GridActionsCellItem
                    icon={<VisibilityIcon />}
                    label="view"
                    className="textPrimary"
                    onClick={() => handleActionButton(row, false)}
                    color="inherit"
                  />
                );
              }

              return actionsList;
            },
          },
        ]
      : [
        {
          field: "actions",
          type: "actions",
          headerName: "Actions",
          width: 160,
          cellClassName: "actions",
          getActions: ({ row }) => {
            let actionsList = [];

            // if (UserAuthorisation?.["Edit"] === "Y") {
              actionsList.push(
                <GridActionsCellItem
                  icon={
                    <Tooltip title="Edit">
                      {" "}
                      <EditIcon />{" "}
                    </Tooltip>
                  }
                  label="Edit"
                  className="textPrimary"
                  onClick={() => {
                    const rowIndex = pageState?.data.findIndex(
                      (item) => item.id === row.id
                    );
                    handleActionButton(row, true, rowIndex); 
                  }}
                  color="inherit"
                />
              );
            // }

            // if (bankTransactions?.['Delete'] === "Y") {
            //   actionsList.push(
            //     <GridActionsCellItem
            //       icon={<Tooltip title="Delete"><DeleteIcon /> </Tooltip>}
            //       label="Delete"
            //       onClick={() => handleDeleteClick(row.id)}
            //       color="inherit"
            //     />
            //   );
            // }

            // if (UserAuthorisation?.["View"] === "Y") {
              actionsList.push(
                <GridActionsCellItem
                  icon={<VisibilityIcon />}
                  label="view"
                  className="textPrimary"
                  onClick={() => handleActionButton(row, false)}
                  color="inherit"
                />
              );
            // }

            return actionsList;
          },
        },
      ]),
  ];
  // const loadData = async () => {
  //   try {
  //     setIsApiCallInprogress(true);
  //     const resp = await instance.get(Broker);
  //     setIsApiCallInprogress(false);
  //     if (resp.status === 200) {
  //       const sortedData = resp.data.sort((a, b) => b.id - a.id);
  //       setTableRows(sortedData);
  //     } else {
  //       setTableRows([]);
  //     }
  //   } catch (err) {
  //     setIsApiCallInprogress(false);
  //     console.error("err", err);
  //   }
  // };
  const UserAuthorisation =
    userData?.user_permissions?.permissions_list["Admin Table Maintenance"];

  const handleInputChange = (index, colName, value) => {
    const updatedRows = [...rows];
    const updatedRow = { ...updatedRows[index], [colName]: value };
    updatedRows[index] = updatedRow;
    if (updatedRows[index]) {
      updatedRows[index][colName] = value;
      setRows([...updatedRows]);
      // Edit Mode
      if (editMode) {
        setCurrentUpdatedFiledsInEditMode({
          ...currentUpdatedFiledsInEditMode,
          [colName]: value,
        });
      }
    } else {
      console.error("Row at index", index, "is undefined.");
    }
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    const updatedSelectedRows = new Array(rows.length).fill(isChecked);

    setSelectedRows(updatedSelectedRows);
    setSelectAll(isChecked);
  };

  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        broker_name: "",
        broker: "",
        branch: "",
        duplicate_count: "",
        soa_received_from_broker: "",
        name: "",
        email: "",
        secondary_email: "",
        phone_number: "",
        broker_branch_location: "",
        bank_acc_name: "",
        bank_acc_number: "",
        currency: "",
        iban_number: "",
        payee_name: "",
        swift_number: "",
        sort_code: ""
      },
    ]);
    setSelectedRows([...selectedRows, false]);
  };

  useEffect(() => {
    const selectedRowCount = selectedRows.filter(Boolean).length;
    if (selectedRowCount < rows.length) {
      setSelectAll(false);
    }
  }, [rows, selectedRows]);

  const handleDeleteRow = () => {
    // Ensure there is at least one row remaining
    console.log("rows", rows);
    if (rows.length <= 1 || selectAll) {
      // Throw an error or show a message indicating that at least one row should remain
      commonToast("error", "At least One Row Should Remain!!");
      return;
    }

    const updatedRows = rows.filter((row, index) => !selectedRows[index]);
    setRows(updatedRows);

    // Clear selected rows and set Select All to false after deletion
    setSelectedRows(selectedRows.filter((ele) => !ele));
    setSelectAll(false);
  };
  const validateRow = (index) => {
    const row = rows[index];
    const fieldValidations = {};

    // Perform your validations here, for example:
    if (!row || !row.broker_name || row.broker_name.trim() === "") {
      fieldValidations.broker_name = "This field is required";
    }
    if (!row || !row.broker || row.broker.trim() === "") {
      fieldValidations.broker = "This field is required";
    }
    if (!row || !row.branch || row.branch.trim() === "") {
      fieldValidations.branch = "This field is required";
    }
    if (!row || !row.duplicate_count || row.duplicate_count.trim() === "") {
      fieldValidations.duplicate_count = "This field is required";
    }
    if (
      !row ||
      !row.soa_received_from_broker||
      !(
        row.soa_received_from_broker.toLowerCase() === "yes" ||
        row.soa_received_from_broker.toLowerCase() === "no"
      )
    ) {
      fieldValidations.soa_received_from_broker = "This field should be Yes/No";
    }
    if (
      !row ||
      !row.soa_received_from_broker ||
      row.soa_received_from_broker.trim() === ""
    ) {
      fieldValidations.soa_received_from_broker = "This field is required";
    }
   
    if (!row || !row.name || row.name.trim() === "") {
      fieldValidations.name = "This field is required";
    }
    // Updated email validation logic
    if (!row || (!row.email && !row.decrypted_email)) {
      fieldValidations.decrypted_email = "Email field is required";
    } else if (row.decrypted_email && !/^\S+@\S+\.\S+$/.test(row.decrypted_email.trim())) {
      fieldValidations.decrypted_email = "Please enter a valid email address";
    } else if (row.email && !/^\S+@\S+\.\S+$/.test(row.email.trim())) {
      fieldValidations.email = "Please enter a valid email address";
    // if (!row || !row.decrypted_email || row.decrypted_email.trim() === "") {
    //   fieldValidations.decrypted_email = "Email field is required";
    // } else if (!/^\S+@\S+\.\S+$/.test(row.decrypted_email.trim())) {
    //   fieldValidations.decrypted_email = "Please enter a valid email address";
    }
    
    if (
      !row ||
      !row.broker_branch_location ||
      row.broker_branch_location.trim() === ""
    ) {
      fieldValidations.broker_branch_location = "This field is required";
    }

    // Add more validations for other fields...
    setValidationStatus((prevStatus) => {
      const newStatus = [...prevStatus];
      newStatus[index] = fieldValidations;
      return newStatus;
    });

    return Object.keys(fieldValidations).length === 0;

  };
  const handleSubmit = async () => {
    // Validate each row before submission
    console.log("row", rows)
    const areRowsValid = rows
      .map((_, index) => validateRow(index))
      .every((value) => value);

    let editModeObj = {};
    if (!editMode) {
      // Add Mode
    } else {
      editModeObj.id = editRow?.id;
      editModeObj["updated_by"] = userData?.user_name ?? "";

      editModeObj = { ...editModeObj, ...currentUpdatedFiledsInEditMode };

      const updatedPageState = pageState?.data.map((row) => {
        if (row.id === editRow?.id) {
          // Log the `id` of the row being edited
          console.log(
            "Editing row with ID:",
            row.id,
            "User name",
            userData?.user_name
          );

          return {
            ...row,
            updated_by: userData?.user_name ?? "", // Update the `updated_by` field
          };
        } else {
          return row; // Keep the rest of the rows unchanged
        }
      });

      console.log("Updated Page State:", updatedPageState);

      setPageState((prev) => {
        console.log("Previous Page State:", prev); // Log the previous state

        return {
          ...prev,
          data: updatedPageState, // Assign the new data
        };
      });
    }
    //const areRowsValid = true;

    if (!areRowsValid) {
      // If any row is invalid, stop the submission and display an error
      commonToast("error", "Please fill all required fields.");
      return;
    }

    try {
      let response;
      if (editMode) {
        // Check if encrypted_email or encrypted_phone_number are updated
        if (editModeObj.decrypted_email) {
          editModeObj.email = editModeObj.decrypted_email;
        }
        if (editModeObj.decrypted_phone_number) {
          editModeObj.phone_number = editModeObj.decrypted_phone_number;
        }
        if (editModeObj.hasOwnProperty('decrypted_email')) {
          delete editModeObj['decrypted_email'];
        }
        if (editModeObj.hasOwnProperty('decrypted_phone_number')) {
          delete editModeObj['decrypted_phone_number'];
        }

        response = await instance.patch(Broker + editId + "/", editModeObj);
        // clear previously updated stored data
        setCurrentUpdatedFiledsInEditMode({});
      } else {
        // const flattenedRows = rows.flat();
        rows.forEach((item) => {
          item.created_by = userData?.user_name ?? "";
        });
        response = await instance.post(Broker, rows);
      }

      if (response) {
        if (editMode) {
          commonToast("success", "Updated successfully !");
        } else {
          commonToast("success", "Submission successful !");
        }

        // clean up
        cleanupTransactionData();
      }
    } catch (err) {
      commonToast("error", "Submission failed. Please try again.");
    }
  };

  const cleanupTransactionData = () => {
    handleDialogClose();
    loadData();
  };

  const handleReset = () => {
    const emptyRows = Array.from({ length: rows.length }, () => ({
      broker_name: "",
      broker: "",
      branch: "",
      duplicate_count: "",
      soa_received_from_broker: "",
      name: "",
      email: "",
      secondary_email: "",
      phone_number: "",
      broker_branch_location: "",
      bank_acc_name: "",
      bank_acc_number: "",
      currency: "",
      iban_number: "",
      payee_name: "",
      swift_number: "",
      sort_code: ""
    }));
    setRows(emptyRows);
    setSelectAll(false);
    setValidationStatus(Array.from({ length: rows.length }, () => true));
    setSelectedRows(selectedRows.fill(false));
  };

  const handleDecryptClick = async (index, id, type, row) => {
    try {
      const response = await instance.post(`/documents/decrypt_data/`, { id, type });
      if (response.status === 200) {
        const decryptedValue = response.data;
        
        // Create a new copy of the data array
        const updatedData = [...pageState.data];
        // Update the specific field in the copied array
        updatedData[index] = {
          ...updatedData[index],
          [type]: decryptedValue[type]
        };
  
        // Update state with the new array
        setPageState((old) => ({
          ...old,
          data: updatedData
        }));
      }
    } catch (error) {
      console.error('Failed to decrypt:', error);
    }
  };
  const handleDownloadBtnClick = () => {
    setIsDownloadInProgress(true);
    try {
      instance
        .get(`${downloadBrokerInfo}`, { responseType: "blob" })
        .then((response) => {
          const url = URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          const fileName = `BrokerInformation_${format(new Date(), "dd-MM-yyyy")}`
          link.setAttribute("download", `${fileName}.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setIsDownloadInProgress(false);
          commonToast("success", "Broker Information data has been downloaded successfully");
        }).catch((err) => {
          console.log(err);
          setIsDownloadInProgress(false);
          commonToast("error", "Broker Information data could not be downloaded");
        });
    } catch (error) {
      setIsDownloadInProgress(false);
      console.log(error);
      commonToast("error", "Broker Information data could not be downloaded");
    }
  }

  return (
    <div style={Container}>
      <div style={AssignBankStatementBar}>
        <span style={{ color: "#FF5A01", fontSize: "24px" }}>Broker Table</span>
        <div style={{ display: "flex", marginRight: "10px" }}>
          {UserAuthorisation?.["Creation"] === "Y" && (
            <>
            <CommonButton
              text="Add"
              handleClick={() => handleActionButton()}
              sx={bankTransactionAddBtn}
              hoverColor="#FF5A01"
            />
            <CommonButton
              text="Export"
              handleClick={handleDownloadBtnClick}
              sx={downloadBtn}
              hoverColor="#FF5A01"
              disabled={isDownloadInProgress}
            />
            </>
          )}
        </div>
      </div>
      <Grid container
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          mb: "10px",
        }}
        xs={12}
        gap={"10px"}
      >
        <Grid
          item
          display={"flex"}
          flexDirection={"column"}
          gap={"2px"}
          xs={3}
        >
          <FormLabel>Broker Master</FormLabel>
          {/* <input
            style={bankStatementSearchBar}
            type="text"
            placeholder="Search..."
            value={searchText}
          // onChange={handleSearch}
          /> */}
          <TextField
            value={searchFieldParams.Broker_Name}
            onChange={(e) =>
              handleBrokerInputChange(e.target.value)
            }
            // sx={InlineStyle.EntityDivison}
            size="small"
            placeholder="Enter Details Here"
            onKeyUp={(e) => handleEnter(e)}
          />
        </Grid>
        <Grid
          item
          display={"flex"}
          flexDirection={"column"}
          gap={"2px"}
          xs={3}
        >
          <FormLabel>Broker Branch</FormLabel>
          <div onKeyUp={(e) => handleEnter(e)}>
            <CommonSelect
              handleChange={(event, value, reason) =>
                handleBrokerBranchDropdownChange(
                  // index,
                  "Broker_Branch",
                  value,
                  reason,
                  event
                )
              }
              options={dropdownValuesBrokerBranch
              }
              placeholder="Select Broker Branch"
              value={searchFieldParams?.Broker_Branch}
            />
          </div>
        </Grid>
        <Grid
          item
          display={"flex"}
          flexDirection={"column"}
          gap={"2px"}
          xs={3}
        >
          <FormLabel>Broker Email</FormLabel>
          <TextField
            value={searchFieldParams.Broker_Email}
            onChange={(e) =>
              handleSearchInputchange("Broker_Email", e.target.value)
            }
            size="small"
            placeholder="Enter Details Here"
            onKeyUp={(e) => handleEnter(e)}
          /> 
        </Grid>
        <Grid item display={"flex"} gap={"10px"} mt={"22px"} >
          <FormLabel></FormLabel>
          <CommonButton
            text="Search"
            handleClick={handleSearchAdmnBrokerList}
            hoverColor="#EE3F00"
            disabled={pageState?.isLoading || isFilterBtnDisable()}
          />
          <FormLabel></FormLabel>
          <CommonButton
            text="Clear"
            handleClick={handleClearSearchList}
            hoverColor="#EE3F00"
            disabled={pageState?.isLoading || isFilterBtnDisable()}
            style={{ color: isFilterBtnDisable() ?? "rgba(0, 0, 0, 0.26)" }}
          />
        </Grid>
      </Grid>

      <div
        style={{
          height: "calc(100vh - 296px)",
          position: "relative",
          display: "flex",
          flexDirection: "row-reverse",
        }}
      >
        <DataGrid
          className={classes.pagination}
          loading={pageState?.isLoading}
          rows={pageState?.data ?? []}
          columns={columns}
          rowCount={pageState?.total}
          keepNonExistentRowsSelected
          disableSelectionOnClick
          pagination
          paginationMode="server"
          getRowId={(row) => row?.id}
          page={pageState.page - 1}
          pageSize={pageState?.pageSize ?? 10}
          pageSizeOptions
          rowsPerPageOptions={[10, 25, 50, 100]}
          // hideFooterPagination // Added on July 2 2024
          // hideFooter
          // loading={isApiCallInprogress}
          // rows={tableRows.slice((page) * pageSize, (page + 1) * pageSize)}
          // pageSize={pageSize}
          // rowCount={tableRows?.length}
          // rowsPerPageOptions={[5, 10, 25, 50, 100]}
          // onPageChange={(newPage) => {
          //   setPage(newPage);
          // }}
          // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          // showCellRightBorder={true}
          // rowHeight={38}
          onPageSizeChange={(newPageSize) => {
            return setPageState((old) => {
              setPaginationCount(Math.floor(pageState.total / newPageSize));
              return { ...old, pageSize: newPageSize, page: 1 };
            });
          }}
          components={{
            Toolbar: GridToolbarContainer, // Custom toolbar for filter reset button
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                No Broker Table Maintenance
              </Stack>
            ),
          }}
          sx={{
            "& .MuiDataGrid-columnHeader[data-field='actions']": {
              minWidth: toggle?.isOpen
                ? "106px !important"
                : "123px !important",
            },
          }}
        />
        
         <Stack
          style={{
            position: "absolute",
            bottom: "8px",
          }}
        >
          <CommonPaginationContainer
            count={paginationCount + 1}
            pageState={pageState}
            setPageState={setPageState}
          />
        </Stack>
      </div>
      {/*
        // Commented on July 2 2024
       <MyComponent /> */}
      <Dialog
        open={EntityDialog}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        PaperProps={{ style: dialogStyle }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ cursor: "default", paddingBottom: "0px" }}
        >
          {viewMode ? "View Broker" : editMode ? "Edit Broker" : "Add Broker"}
          <IconButton
            aria-label="close"
            onClick={handleDialogClose}
            style={{ position: "absolute", right: 12, top: 12 }}
          >
            <CloseIcon style={CloseIconStyle} />
          </IconButton>
          <hr style={{ width: "100%" }} />
        </DialogTitle>
        <DialogContent
          sx={{ overflowX: "hidden", padding: "0px 24px 5px 24px" }}
        >
          <div elevation={4} style={EditPageContainerTransactions}>
            {!editMode && !viewMode && (
              <div style={EditPageContainerTransactionsList}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <CommonButton
                    // sx={addBankTransactionAdd}
                    text="Add"
                    handleClick={handleAddRow}
                    icon={<AddIcon style={{ height: "18px" }} />}
                    hoverColor="#FF5A01"
                  />
                  <CommonButton
                    sx={{
                      backgroundColor: selectAll ? "#FF5A01" : "#CCCCCC",
                      color: selectAll ? "white" : "black",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "17px 10px",
                      borderRadius: "15px",
                      "&:hover": {
                        background: selectAll ? "#FF5A01" : "#CCCCCC",
                      },
                    }}
                    text="Delete"
                    handleClick={handleDeleteRow}
                    disabled={selectedRows.filter(Boolean).length === 0}
                    icon={<DeleteIcon style={{ height: "19px" }} />}
                  />
                </div>
              </div>
            )}
            {isCreated ? (
              <TableContainer style={{ maxHeight: "300px" }}>
                <AddBrokerDetails
                  selectAll={selectAll}
                  handleInputChange={handleInputChange}
                  handleSelectAll={handleSelectAll}
                  rows={rows}
                  // handleBlur={handleBlur}
                  handleCheckboxChange={handleCheckboxChange}
                  validationStatus={validationStatus}
                  selectedRows={selectedRows}
                />
              </TableContainer>
            ) : (
              <>
                {rows?.map((row, index) => (
                  <Grid display={"flex"} flexDirection={"column"}>
                    <ViewAndEditEntity
                      row={row}
                      index={index}
                      viewMode={viewMode}
                      validationStatus={validationStatus}
                      editMode={editMode}
                      handleInputChange={handleInputChange}
                      isUserCCProcessor={userData?.role == "CC Processor"}
                    />
                  </Grid>
                ))}
              </>
            )}
          </div>
        </DialogContent>

        <DialogActions style={ResetSubmit}>
          {viewMode ? null : (
            <>
              {isCreated && (
                <CommonButton
                  sx={addBankTransactionReset}
                  text="Reset"
                  handleClick={() => handleReset()}
                  disabled={editMode}
                />
              )}
              {editMode && (
                <CommonButton
                  sx={editEntityUpdate}
                  text="Update"
                  handleClick={handleSubmit}
                  // disabled={isDisableUpdateBtn}
                  disabled={Object.keys(currentUpdatedFiledsInEditMode)?.length <= 0}
                  hoverColor="#FF5A01"
                />
              )}
              {!editMode && !viewMode && (
                <CommonButton
                  sx={addBankTransactionSubmit}
                  text="Submit"
                  handleClick={handleSubmit}
                  hoverColor="#FF5A01"
                />
              )}
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
